import { Routes } from "@angular/router";
import { AdminDashboardComponent } from "../admin/dashboard/feature/dashboard.component";
import { AdminGuard } from "../data-services/guards/admin.guards";
import { ShowComponent } from "../events/show/feature/show.component";
import { EventHostGuard } from "../data-services/guards/event-host.guard";
import { AdminManageComponent } from "../admin/events/manage/feature/manage.component";
import { AuthGuard } from "../data-services/guards/auth.guard";
import { AdminEditBookingComponent } from "../admin/events/manage/bookings/feature/bookings.component";
import { AdminEventDetailsComponent } from "../admin/events/manage/details/feature/details.component";
import { AdminUsersComponent } from "../admin/users/feature/users.component";
import { AdminUsersEditComponent } from "../admin/users/edit/feature/edit.component";
import { AdminEventTicketsComponent } from "../admin/events/manage/tickets/feature/tickets.component";
import { AdminNewEventComponent } from "../admin/events/new/feature/new.component";
import { AdminEventCateringComponent } from "../admin/events/manage/catering/feature/catering.component";
import { OrganiserGuard } from "../data-services/guards/organiser.guard";
import { AdminOrganisersComponent } from "../admin/organisers/feature/organisers.component";
import { OrganiserEditComponent } from "../admin/organisers/edit/feature/edit.component";

export const adminRoutes: Routes = [
    {
        path: 'admin',
        component: AdminDashboardComponent,
        canActivate: [AuthGuard,EventHostGuard],
    },
    {
        path: 'admin/archive',
        component: AdminDashboardComponent,
        canActivate: [AuthGuard, EventHostGuard],
        data: { archive: true }
    },
    {
        path: 'admin/events/new',
        component: AdminNewEventComponent,
        canActivate: [AuthGuard, EventHostGuard]

    },
    {
        path: 'admin/events/:id/booking/:bookingId',
        canActivate: [AuthGuard,EventHostGuard],
        component: AdminEditBookingComponent
    },
    {
        path: 'admin/events/:id/details',
        canActivate: [AuthGuard,EventHostGuard],
        component: AdminEventDetailsComponent
    },
    {
        path: 'admin/events/:id/tickets',
        canActivate: [AuthGuard,EventHostGuard],
        component: AdminEventTicketsComponent
    },
    {
        path: 'admin/events/:id/catering',
        canActivate: [AuthGuard,EventHostGuard],
        component: AdminEventCateringComponent
    },
    {
        path: 'admin/events/:id',
        canActivate: [AuthGuard,EventHostGuard],
        component: AdminManageComponent
    },
    {
        path: 'admin/users',
        canActivate: [AuthGuard, EventHostGuard],
        component: AdminUsersComponent
    },
    {
        path: 'admin/users/:id',
        canActivate: [AuthGuard, EventHostGuard],
        component: AdminUsersEditComponent
    },
    {
        path: 'admin/organisers',
        canActivate: [AuthGuard, OrganiserGuard],
        component: AdminOrganisersComponent
    },
    {
        path: 'admin/organisers/:id',
        canActivate: [AuthGuard, OrganiserGuard],
        component: OrganiserEditComponent
    }
]